"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaTagColors = exports.LunaTagSizes = exports.LunaTagTypes = void 0;

var _colors, _types, _sizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaTagTypes = {
  tag30: 'tag30',
  tag10: 'tag10'
};
exports.LunaTagTypes = LunaTagTypes;
var LunaTagSizes = {
  "default": 'default',
  small: 'small'
};
exports.LunaTagSizes = LunaTagSizes;
var LunaTagColors = {
  neutral: 'neutral',
  green: 'green',
  orange: 'orange',
  red: 'red',
  blue: 'blue'
};
exports.LunaTagColors = LunaTagColors;
var __baseClass = 'luna-tag';
var classes = {
  base: __baseClass,
  childIcon: "".concat(__baseClass, "--icon"),
  colors: (_colors = {}, _defineProperty(_colors, LunaTagColors.neutral, "".concat(__baseClass, "-neutral")), _defineProperty(_colors, LunaTagColors.green, "".concat(__baseClass, "-green")), _defineProperty(_colors, LunaTagColors.orange, "".concat(__baseClass, "-orange")), _defineProperty(_colors, LunaTagColors.red, "".concat(__baseClass, "-red")), _defineProperty(_colors, LunaTagColors.blue, "".concat(__baseClass, "-blue")), _colors),
  content: "".concat(__baseClass, "--content"),
  disabled: "".concat(__baseClass, "-disabled"),
  types: (_types = {}, _defineProperty(_types, LunaTagTypes.tag30, "".concat(__baseClass, "-30")), _defineProperty(_types, LunaTagTypes.tag10, "".concat(__baseClass, "-10")), _types),
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaTagSizes["default"], "".concat(__baseClass, "-default")), _defineProperty(_sizes, LunaTagSizes.small, "".concat(__baseClass, "-small")), _sizes),
  iconClass: "".concat(__baseClass, "-icon"),
  labelClass: "".concat(__baseClass, "-label")
};
exports.classes = classes;
